import api from './api';

const billingAPI = {
  // Get monthly bill for a specific room and period
  getMonthlyBill: (roomId, month, year) => 
    api.get(`/billing/room/${roomId}/${year}/${month}`),

  // Get room financial summary
  getRoomSummary: (roomId) => 
    api.get(`/billing/room/${roomId}/summary`),

  // Record a unified payment
  recordPayment: (paymentData) => 
    api.post('/billing/payment', paymentData),

  // Get room bills for a year
  getRoomBills: (roomId, year) => 
    api.get(`/billing/room/${roomId}/bills`, { params: { year } }),
};

export default billingAPI;
